module.exports = __webpack_public_path__ + "static/img/7.de583aa.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/7/7.png
// module id = 285
// module chunks = 0